import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import {OnFailureData, OnSuccess} from "../../../../store/action/actionHelpers";
import SingleFileSelector from "../../../file/SingleFileSelector";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../helper/Toast";
import {Option, option} from "ts-option";
import {ImportResult} from "../../../../model/importResult/ImportResult";
import {uploadPartnerBrands} from "../../../../store/action/partnerBrand/partnerBrand";

interface IComponentProps {
	/**
	 * On successful partner brand upload callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IDispatchProps {
	/**
	 * Upload partner brands from xlsx file.
	 * @param {File} file
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailureData<ImportResult>} onFailure
	 */
	uploadPartnerBrands: (file: File, onSuccess: OnSuccess, onFailure: OnFailureData<Option<ImportResult>>) => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

type Props = IComponentProps & IDispatchProps;

class UploadPartnerBrandModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Upload partner brand"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onCancel}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}/>
			</Modal>
		);
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				this.props.uploadPartnerBrands(file,
					() => {
						Toast.success("Partner Brands uploaded successfully.", "Partner Brands upload");
						this.setState({filesUploading: false});
						this.props.onSuccess();
					},
					(result: Option<ImportResult>) => {
						const errors = result.map(e => e.error).getOrElse([]);
						this.setState({errors: errors, filesUploading: false});
						Toast.error("Cannot upload partner brands.", "Partner Brands upload");
					});
			});
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		uploadPartnerBrands: (file: File, onSuccess: OnSuccess, onFailure: OnFailureData<Option<ImportResult>>) => dispatch(
			uploadPartnerBrands(file, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)(UploadPartnerBrandModal);
